import React, { useEffect, useState } from "react";
import "./Admin.css";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../components/Loader";
import axios from "axios";
import ProfitModal from "./components/ProfitModal";

const Transactions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [transactions, setTransactions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [isLoading, setIsLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [pendingSearch, setPendingSearch] = useState(""); 


  useEffect(() => {
    const token = window.sessionStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    setIsLoading(true);
    setTransactions([]);

    const queryParams = new URLSearchParams(location.search);

    if (searchTerm) {
      queryParams.set("search", searchTerm);
    }

    const url = `${
      process.env.REACT_APP_API_URL
    }/transactions?page=${currentPage}&limit=${itemsPerPage}&${queryParams.toString()}`;

    axios
      .get(url, { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => {
        if (response.data.success) {
          setTransactions(response.data.transactions);
          setCount(response.data.count);
        } else {
          setTransactions([]);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error.response && error.response.status === 401) {
          window.sessionStorage.clear();
          navigate("/login");
        }
      });
  }, [location.search, navigate, currentPage, itemsPerPage, searchTerm]);


  const handleSearchChange = (e) => {
    setPendingSearch(e.target.value);
  };

  const handleSearchSubmit = () => {
    setSearchTerm(pendingSearch);
    setCurrentPage(1);
  };



  const totalItems = count;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = Math.min(startIndex + itemsPerPage, totalItems);


  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const formatDate = (dateTimeString) => {
    const date = new Date(dateTimeString);
    const options = { year: "numeric", month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const formatTime = (dateTimeString) => {
    const date = new Date(dateTimeString);
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const amPM = hours >= 12 ? "PM" : "AM";

    hours = hours % 12 || 12;
    hours = hours.toString().padStart(2, "0");

    return `${hours}:${minutes} ${amPM}`;
  };

  const formatCurrency = (value) => {
    const number = Number(value);

    if (!Number.isFinite(number)) {
      return "Invalid number";
    }

    return number.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  return (
    <div className="page-wrapper default-version">
      <AdminSidebar active={"transaction"} />
      <AdminHeader />

      {isLoading ? (
        <Loader />
      ) : (
        <div className="body-wrapper">
          <div className="bodywrapper__inner">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="page-title">Transactions: {count}</h6>

              <div className="d-flex flex-wrap justify-content-end align-items-center breadcrumb-plugins">
                <div className="input-group w-auto flex-fill">
                  <input
                    type="search"
                    name="search"
                    className="form-control bg--white text--white"
                    placeholder="Transaction ID or Username"
                    value={pendingSearch}
                    onChange={handleSearchChange}
                  />
                  <button
                    className="btn btn--primary"
                    type="button"
                    onClick={handleSearchSubmit}
                  >
                    <i className="la la-search" />
                  </button>
                </div>
              </div>
            </div>

            <input type="hidden" value={count} />

            <div className="row mt-3">
              <div className="col-lg-12">
                <div className="card b-radius--10 ">
                  <div className="card-body p-0">
                    <div className="table-responsive--md  table-responsive">
                      <table className="table table--light style--two">
                        <thead>
                          <tr>
                            <th>Transaction ID</th>
                            <th>User</th>
                            <th>Action</th>
                            <th>Amount Paid</th>
                            <th>Revenue</th>
                            <th>Transaction Date</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {transactions.length === 0 ? (
                            <tr>
                              <td colSpan="8">No data</td>{" "}
                            </tr>
                          ) : (
                            transactions.map((transaction) => (
                              <tr>
                                <td>
                                  <div className="user">
                                    <div className="thumb">
                                      <img
                                        src={
                                          transaction.currencyId
                                            ? transaction.currencyId
                                                .currencyLogo
                                            : "/assets/images/currency/btc.png"
                                        }
                                        alt="user"
                                      />
                                    </div>
                                    <span className="name fw-bold">
                                      {transaction.currencyId
                                        ? transaction.currencyId.currencyName
                                        : "Bitcoin (BTC)"}
                                      <br />
                                      <small className="text-muted fw-bold">
                                        {transaction.transactionId}
                                      </small>
                                    </span>
                                  </div>
                                </td>
                                <td>
                                  <span className="d-block">
                                    {transaction?.userId?.firstname}{" "}
                                    {transaction?.userId?.surname}
                                  </span>
                                  <span>
                                    <a
                                      className="text--primary"
                                      href={`/admin/users/details/${transaction?.userId?._id}`}
                                    >
                                      <span className="text--primary">@</span>
                                      {transaction?.userId?.username}
                                    </a>
                                  </span>
                                </td>
                                <td>
                                  <span className="d-block">
                                    {capitalizeFirstLetter(
                                      transaction?.transactionType
                                    )}
                                  </span>
                                  <span className="text--primary">
                                    {transaction.currencyId
                                      ? transaction.currencyId.currencyName
                                      : "Bitcoin (BTC)"}
                                  </span>
                                </td>
                                <td>
                                  <span className="d-block">
                                    {transaction?.transactionType === "receive"
                                      ? formatCurrency(
                                          Number(transaction?.amountGhs) -
                                            Number(
                                              transaction?.transactionFee *
                                                transaction?.exchangeRate
                                            )
                                        )
                                      : formatCurrency(
                                          transaction?.amountGhs
                                        )}{" "}
                                    GHS
                                  </span>
                                  <span>
                                    {formatCurrency(transaction?.amountUsd)}{" "}
                                    {transaction?.currencyId?.currencyCode
                                      .toLowerCase()
                                      .includes("rmb")
                                      ? "RMB"
                                      : "USD"}
                                  </span>
                                </td>

                                <td>
                                  <span className="d-block">
                                    {formatCurrency(transaction?.revenue)} GHS
                                  </span>
                                  {transaction?.status === "success" &&
                                    !transaction?.profitEarned && (
                                      <ProfitModal
                                        transaction={transaction}
                                        setIsLoading={setIsLoading}
                                      />
                                    )}
                                </td>

                                <td>
                                  <span className="d-block">
                                    {formatDate(transaction.createdAt)}
                                  </span>
                                  <span>
                                    {formatTime(transaction.createdAt)}
                                  </span>
                                </td>

                                <td>
                                  {transaction.status === "success" ? (
                                    <span className="badge badge--success">
                                      Success
                                    </span>
                                  ) : transaction.status === "pending" ? (
                                    <span className="badge badge--primary">
                                      Pending
                                    </span>
                                  ) : transaction.status === "processing" ? (
                                    <span className="badge badge--warning">
                                      Processing
                                    </span>
                                  ) : transaction.status === "cancelled" ? (
                                    <span className="badge badge--danger">
                                      Cancelled
                                    </span>
                                  ) : (
                                    <span className="badge badge--danger">
                                      Failed
                                    </span>
                                  )}
                                </td>
                                <td>
                                  <a
                                    href={`/admin/transactions/details/${transaction._id}`}
                                    className="btn btn-sm btn-outline--primary"
                                  >
                                    <i className="las la-desktop" />
                                    Details
                                  </a>
                                </td>
                              </tr>
                            ))
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {transactions.length === 0 ? (
                    <p>No transactions found</p>
                  ) : (
                    <div className="card-footer py-4">
                      <nav>
                        <ul className="pagination">
                          <li
                            className="page-item"
                            onClick={() => goToPage(currentPage - 1)}
                          >
                            <button
                              className="page-link"
                              disabled={currentPage === 1}
                            >
                              «
                            </button>
                          </li>

                          {currentPage > 2 && (
                            <li className="page-item">
                              <button
                                className="page-link"
                                onClick={() => goToPage(1)}
                              >
                                1
                              </button>
                            </li>
                          )}

                          {currentPage > 3 && (
                            <li className="page-item disabled">
                              <button className="page-link">...</button>
                            </li>
                          )}

                          {[...Array(totalPages)]
                            .map((_, index) => index + 1)
                            .filter(
                              (page) =>
                                page === currentPage ||
                                page === currentPage - 1 ||
                                page === currentPage + 1
                            )
                            .map((page) => (
                              <li
                                key={page}
                                className={`page-item ${
                                  page === currentPage ? "active" : ""
                                }`}
                              >
                                <button
                                  className="page-link"
                                  onClick={() => goToPage(page)}
                                >
                                  {page}
                                </button>
                              </li>
                            ))}

                          {currentPage < totalPages - 2 && (
                            <li className="page-item disabled">
                              <button className="page-link">...</button>
                            </li>
                          )}

                          {currentPage < totalPages - 1 && (
                            <li className="page-item">
                              <button
                                className="page-link"
                                onClick={() => goToPage(totalPages)}
                              >
                                {totalPages}
                              </button>
                            </li>
                          )}

                          <li
                            className="page-item"
                            onClick={() => goToPage(currentPage + 1)}
                          >
                            <button
                              className="page-link"
                              disabled={currentPage === totalPages}
                            >
                              »
                            </button>
                          </li>
                        </ul>
                      </nav>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <></>
    </div>
  );
};

export default Transactions;
